if (!customElements.get('nearheld-sticky-cart')) {
  customElements.define('nearheld-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      const source = this.closest('product-info').querySelector('product-form .product-form__submit');
      if (!source) return;

      const button = source.cloneNode(true);
      button.removeAttribute('id');
      button.removeAttribute('name');
      button.type = 'button';
      button.addEventListener('click', () => source.click());
      const price = document.createElement('span');
      price.className = 'nearheld-sticky-cart__price';
      const sourcePrice = this.closest('product-info').querySelector('.price-item--last');
      this.replaceChildren(price, button);

      const sync = () => {
        price.textContent = sourcePrice?.textContent.trim().replace(/\s*[A-Z]{3}$/, '') ?? '';
        button.innerHTML = source.innerHTML;
        button.disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
        button.classList.toggle('loading', source.classList.contains('loading'));
        const error = source.closest('product-form').querySelector('.product-form__error-message-wrapper');
        if (error && !error.hidden) error.scrollIntoView({ block: 'center' });
      };
      sync();
      this.mutations = new MutationObserver(sync);
      this.mutations.observe(source, { attributes: true, childList: true, subtree: true, characterData: true });
      this.updatePosition = () => {
        const rect = source.getBoundingClientRect();
        this.hidden = rect.bottom > 0 && rect.top < window.innerHeight;
      };
      window.addEventListener('scroll', this.updatePosition, { passive: true });
      window.addEventListener('resize', this.updatePosition);
      this.updatePosition();
    }

    disconnectedCallback() {
      this.mutations?.disconnect();
      window.removeEventListener('scroll', this.updatePosition);
      window.removeEventListener('resize', this.updatePosition);
    }
  });
}
